// extracted by mini-css-extract-plugin
export default {"header":"Interviews-module__header__otkCC","departmentFilter":"Interviews-module__departmentFilter__gQHWA","button":"Interviews-module__button__QXDKN"};